var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCaretDownFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.05864 13.925L3.06364 7.0725C2.35614 6.26625 2.93114 5 4.00489 5H15.9949C16.2352 4.99979 16.4705 5.06886 16.6725 5.19893C16.8746 5.32899 17.0349 5.51455 17.1342 5.73337C17.2335 5.95219 17.2677 6.195 17.2325 6.43272C17.1974 6.67045 17.0945 6.89301 16.9361 7.07375L10.9411 13.9237C10.8238 14.058 10.6791 14.1656 10.5168 14.2393C10.3544 14.3131 10.1782 14.3512 9.99989 14.3512C9.82159 14.3512 9.64535 14.3131 9.48301 14.2393C9.32066 14.1656 9.17597 14.058 9.05864 13.9237V13.925Z",
    fill: "#4B4B4B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretDownFill);
export default __webpack_public_path__ + "static/media/caret_down_fill.b13a10b91cc996f684e929506596647b.svg";
export { ForwardRef as ReactComponent };